document.addEventListener('DOMContentLoaded', function() {
  const sliderWrapper = document.querySelector('.custom-slider-wrapper');
  const slider = document.querySelector('.custom-slider');
  const prevArrow = document.querySelector('.prev-arrow');
  const nextArrow = document.querySelector('.next-arrow');
  let isDown = false;
  let startX;
  let scrollLeft;

  const scrollSlider = (direction) => {
    const slideWidth = slider.querySelector('.slide').clientWidth;
    slider.scrollBy({
      left: direction * slideWidth,
      behavior: 'smooth'
    });
  };

  prevArrow.addEventListener('click', () => scrollSlider(-1));
  nextArrow.addEventListener('click', () => scrollSlider(1));

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
  
  // Set number of columns for desktop and mobile
  const root = document.documentElement;
  const desktopColumns = slider.dataset.desktopColumns || 4;
  const mobileColumns = slider.dataset.mobileColumns || 1;
  root.style.setProperty('--desktop-columns', desktopColumns);
  root.style.setProperty('--mobile-columns', mobileColumns);

  // Autoplay functionality
  const autoplay = slider.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 3000;

  if (autoplay) {
    setInterval(() => {
      scrollSlider(1);
    }, autoplaySpeed);
  }
});
